export default {
      id: "item-gradient-usage",
      viewBox: "0 0 118 136",
      url: __webpack_public_path__ + "img/icons.svg#item-gradient",
      toString: function () {
        return this.url;
      }
    }